export default __webpack_public_path__ + "static/media/logo_tecnopolis.cad23f47.png";